import type * as z from "zod";
import { searchInputOf, searchResultOf } from "../search";

// What party finds (ADR-117), for the staff of Tomorrow only, as its lists. Each type needs the permission of its
// list, and the same one opens it in the app.

export const partySearchTypes = ["organization", "contact", "manufacturer", "etaf", "user", "role"] as const;
export type PartySearchType = (typeof partySearchTypes)[number];

export const partySearchPermissions = {
  organization: "organization.read",
  contact: "organization.read",
  manufacturer: "organization.read",
  etaf: "etaf.read",
  user: "user.read",
  role: "user.read",
} as const satisfies Record<PartySearchType, string>;

export const searchPartyInput = searchInputOf(partySearchTypes);
export type SearchPartyInput = z.input<typeof searchPartyInput>;

export const partySearchDto = searchResultOf(partySearchTypes).meta({ id: "PartySearch" });
export type PartySearch = z.output<typeof partySearchDto>;
